import React, { Component } from "react";

export default class LoginButton extends Component {
  render() {
    return (
      <button
        onClick={this.props.onButtonClicked}
        className={`login-button${this.props.showText ? " login-button--show-text" : ""}`}
      >
        <img
          src="/img/login_icon.png"
          alt="User Icon"
          className="icon"
          style={{ marginBottom: "0" }}
        />
        {this.props.btnText}
      </button>
    );
  }
}
